import React from 'react';
import {
  useState,
  useCallback,
  useRef,
  useEffect,
} from 'react';
import {get} from 'lodash';
import className from 'classnames';

export const useModal = (options = {}) => {
  const [modal, modalSet] = useState(options.defaultValue ? options.defaultValue : false)

  const $submitButton = useRef()
  if (options.keyboardBindings) {
    // `onKeydown` has to be a useRef or else it will loss a reference
    // upon re-rendering. It cannot be a function outside hook
    // because it still needs to access $submitButton.
    const onKeydown = useRef()

    useEffect(() => {
      if (modal) {
        // `onKeydown` has to be set every time to update the value of `modals`
        onKeydown.current = (e) => {
          switch (e.key.toLowerCase()) {
            case 'escape':
              return modalSet(false)
            case 'enter':
              if (
                $submitButton &&
                $submitButton.current
              ) {
                $submitButton.current.click()
              }

              return
          }
        }

        document.addEventListener('keydown', onKeydown.current);
      }
      else {
        document.removeEventListener('keydown', onKeydown.current);
      }
    })
  }

  return [
    modal,
    modalSet,
    $submitButton,
  ]
}

export const useCheckIds = ({
  data = [],
  openUrl = '',
}) => {
  const [checkIds, setCheckIds] = useState([])

  const onCheck = useCallback(
    (d) => {
      return () => {
        setCheckIds((prevState) => {
          return prevState.includes(d.id) ?
            prevState.filter((x) => x != d.id)
          :
            [
              ...prevState,
              d.id,
            ]
        })
      }
    },
    []  // Never change this.
  )

  const renderCheckBox = useCallback(
    (d) => {
      return (
        <a
          className={className('CheckBox', {
            'CheckBox--active': checkIds.includes(d.id),
          })}
          onClick={onCheck(d)}
        />
      )
    },
    [checkIds.length]  // Re-render if checkIds changes.
  )

  const renderCheckBoxForCheckAll = useCallback(
    () => {
      return (
        <div className='TableChecker__left'>
          <a
            className='TableChecker__left__a'
            onClick={() => {
              if (checkIds.length < data.length) {
                setCheckIds(data.map((x) => x.id))
              }
              else {
                setCheckIds([])
              }
            }}
          >
            <span
              className={className('CheckBox', {
                'CheckBox--partial': get(checkIds, 'length') > 0,
                'CheckBox--active': get(checkIds, 'length') == get(data, 'length') && get(checkIds, 'length') != 0,
              })}
            />
            <span>
              <strong>{get(checkIds, 'length', 0)}</strong> {openUrl} were selected
            </span>
          </a>
        </div>
      )
    },
    [checkIds.length]  // Re-render if checkIds changes.
  )

  const renderOpenAllButton = useCallback(
    () => {
      return (
        <React.Fragment>
          {checkIds.length !== 0 &&
            <div className='MainHeader__right'>
              <a
                className='MainHeader__right__a'
                onClick={() => {
                  checkIds.map((id) => {
                    window.open(`/${gon.currentProvider}/${openUrl}/${id}`)
                  })
                }}
              >
                Open all {checkIds.length} rows
              </a>
            </div>
          }
        </React.Fragment>
      )
    },
    [checkIds.length]
  )

  const shouldDisableAction = checkIds.length === 0

  return {
    checkIds,
    onCheck,
    setCheckIds,
    renderCheckBox,
    renderCheckBoxForCheckAll,
    renderOpenAllButton,
    shouldDisableAction
  }
}
